module.exports = __webpack_public_path__ + "img/744.6b82ee1d.jpg";